import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KitchenAngularModule } from '@inmoment/the-kitchen-angular';

import { AppSharedModule } from 'app/app-shared.module';

import { LexXiFilterPillComponent } from 'app/components/xi-components/lex-xi-filter-pill/lex-xi-filter-pill.component';
import { CollectionModule } from 'app/modules/collection/collection.module';

import { InteractiveSmartSummaryService } from 'app/providers/storage-api/interactive-smart-summary.service';
import { ActionPlanModule } from '../action-plan/action-plan.module';
import { DocumentListSettingsDialogComponent } from '../collection/components/document/document-list-settings-dialog/document-list-settings-dialog.component';
import { IsIconDisabledPipe } from '../collection/components/document/document-list-settings-dialog/is-icon-disabled.pipe';
import { ProjectModule } from '../project/project.module';
import { DashboardPillWrapperComponent } from '../../components/dashboard-pill-wrapper/dashboard-pill-wrapper.component';
import { ActionPlanDialogComponent } from './components/action-plan-dialog/action-plan-dialog.component';
import { AddToWidgetGroupDialogComponent } from './components/add-to-widget-group-dialog/add-to-widget-group-dialog.component';
import { AnalyticItemSelectorComponent } from './components/analytic-item-selector/analytic-item-selector.component';
import { BigNumberChartOptionsComponent } from './components/big-number-chart-options/big-number-chart-options.component';
import { BigNumberChartOptionsDialogComponent } from './components/big-number-chart-options-dialog/big-number-chart-options-dialog.component';
import { BigNumberMetadataSelectorDialogComponent } from './components/big-number-metadata-selector-dialog/big-number-metadata-selector-dialog.component';
import { BoxScoringDisplayComponent } from './components/box-scoring-display/box-scoring-display.component';
import { ChangeWidgetGroupDialogComponent } from './components/change-widget-group-dialog/change-widget-group-dialog.component';
import { ChartOptionsDialogComponent } from './components/chart-options-dialog/chart-options-dialog.component';
import { CommentCompactCardComponent } from './components/comment-compact-card/comment-compact-card.component';
import { CommentDialogComponent } from './components/comment-dialog/comment-dialog.component';
import { CreateInsightFeedDialogComponent } from './components/create-insight-feed-dialog/create-insight-feed-dialog.component';
import { DocumentListSavedSearchComponent } from './components/document-list-saved-search/document-list-saved-search.component';
import { DonutChartOptionsDialogComponent } from './components/donut-chart-options-dialog/donut-chart-options-dialog.component';
import { GaugeChartOptionsDialogComponent } from './components/gauge-chart-options-dialog/gauge-chart-options-dialog.component';
import { GridAnalyticItemSelectorDialogComponent } from './components/grid-analytic-item-selector-dialog/grid-analytic-item-selector-dialog.component';
import { GridBreakdownTaxonomyConfigComponent } from './components/grid-analytic-item-selector-dialog/grid-breakdown-taxonomy-config/grid-breakdown-taxonomy-config.component';
import { GridChartOptionsDialogComponent } from './components/grid-chart-options-dialog/grid-chart-options-dialog.component';
import { ImpactTableTrendIndicatorComponent } from './components/impact-table-trend-indicator/impact-table-trend-indicator.component';
import { InteractiveSmartSummaryComponent } from './components/interactive-smart-summary/interactive-smart-summary.component';
import { JourneyAnalyticItemSelectorDialogComponent } from './components/journey-analytic-item-selector-dialog/journey-analytic-item-selector-dialog.component';
import { NewspaperWidgletComponent } from './components/newspaper-widglet/newspaper-widglet.component';
import { NumericMetadataFieldSelectorComponent } from './components/numeric-metadata-field-selector/numeric-metadata-field-selector.component';
import { PredictiveBreakdownDriversOptionsDialogComponent } from './components/predictive-breakdown-drivers-options-dialog/predictive-breakdown-drivers-options-dialog.component';
import { PredictiveBreakdownWidgetetteComponent } from './components/predictive-breakdown-widgetette/predictive-breakdown-widgetette.component';
import { PredictiveChartOptionsDialogComponent } from './components/predictive-chart-options-dialog/predictive-chart-options-dialog.component';
import { PredictiveChartWidgetetteComponent } from './components/predictive-chart-widgetette/predictive-chart-widgetette.component';
import { PredictiveCrosstabComponent } from './components/predictive-crosstab/predictive-crosstab.component';
import { PredictiveDriverWidgetetteComponent } from './components/predictive-driver-widgetette/predictive-driver-widgetette.component';
import { PredictiveWidgetDatepickersComponent } from './components/predictive-widget-datepickers/predictive-widget-datepickers.component';
import { SectionSelectorComponent } from './components/section-selector/section-selector.component';
import { SmartSummaryDialogComponent } from './components/smart-summary-dialog/smart-summary-dialog.component';
import { SmartSummaryFeedbackDialogComponent } from './components/smart-summary-feedback-dialog/smart-summary-feedback-dialog.component';
import { TaxonomyPickerComponent } from './components/taxonomy-picker/taxonomy-picker.component';
import { TaxonomySearchDialogComponent } from './components/taxonomy-search/taxonomy-search-dialog.component';
import { WidgetComponent } from './components/widget/widget.component';
import { WidgetAddFeedOptionsComponent } from './components/widget-add/widget-add-feed-options/widget-add-feed-options.component';
import { WidgetAddDialogComponent } from './components/widget-add/widget-add.component';
import { WidgetAnalyticItemDialogComponent } from './components/widget-analytic-item-dialog/widget-analytic-item-dialog.component';
import { WidgetBigNumberComponent } from './components/widget-big-number/widget-big-number.component';
import { WidgetChartScatterplotComponent } from './components/widget-chart-scatterplot/widget-chart-scatterplot.component';
import { WidgetChartVolumeComponent } from './components/widget-chart-volume/widget-chart-volume.component';
import { CrosstabAnalyticItemsDialogComponent } from './components/widget-crosstab/crosstab-analytic-items/crosstab-analytic-items-dialog.component';
import { WidgetCrosstabComponent } from './components/widget-crosstab/widget-crosstab.component';
import { WidgetDocumentListComponent } from './components/widget-document-list/widget-document-list.component';
import { WidgetAiInsightsComponent } from './components/widget-expansion-panel/widget-ai-insights/widget-ai-insights.component';
import { CommentCardComponent } from './components/widget-expansion-panel/widget-comment-list/comment-card/comment-card.component';
import { WidgetCommentListComponent } from './components/widget-expansion-panel/widget-comment-list/widget-comment-list.component';
import { WidgetExpansionPanelComponent } from './components/widget-expansion-panel/widget-expansion-panel.component';
import { SectionFilterPipe } from './components/widget-filter/section-filter.pipe';
import { WidgetFilterDialogComponent } from './components/widget-filter/widget-filter.component';
import { SentimentBarComponent } from './components/widget-grid/sentiment-bar/sentiment-bar.component';
import { SentimentIconComponent } from './components/widget-grid/sentiment-icon/sentiment-icon.component';
import { WidgetGridComponent } from './components/widget-grid/widget-grid.component';
import { RatingFieldSelectorDialogComponent } from './components/widget-impact/rating-field-selector-dialog/rating-field-selector-dialog.component';
import { WidgetImpactComponent } from './components/widget-impact/widget-impact.component';
import { WidgetInsightFeedComponent } from './components/widget-insight-feed/widget-insight-feed.component';
import { JourneyDetailsDialogComponent } from './components/widget-journey/journey-details-dialog/journey-details-dialog.component';
import { WidgetJourneyComponent } from './components/widget-journey/widget-journey.component';
import { WidgetMarkdownComponent } from './components/widget-markdown/widget-markdown.component';
import { WidgetMarkdownEditorComponent } from './components/widget-markdown-editor/widget-markdown-editor.component';
import { WidgetNotesComponent } from './components/widget-notes/widget-notes.component';
import { WidgetNotesEditorComponent } from './components/widget-notes-editor/widget-notes-editor.component';
import { WidgetPredictiveComponent } from './components/widget-predictive/widget-predictive.component';
import { WidgetSentimentAccuracyComponent } from './components/widget-sentiment-accuracy/widget-sentiment-accuracy.component';
import { WidgetSentimentFilterDialogComponent } from './components/widget-sentiment-filter/widget-sentiment-filter.component';
import { WidgetTaxonomyMapComponent } from './components/widget-taxonomy-map/widget-taxonomy-map.component';
import { WidgetTopMoversComponent } from './components/widget-top-movers/widget-top-movers.component';
import { WidgetTopicScoringComponent } from './components/widget-topic-scoring/widget-topic-scoring.component';
import { PinnedCommentDragDirective } from './pinned-comment-drag.directive';
import { ActionPlanIpdService } from './services/action-plan-ipd.service';
import { ChartCommentsService } from './services/chart-comments.service';
import { ChartDataService } from './services/chart-data.service';
import { ChartDisplayService } from './services/chart-display.service';
import { ChartReportService } from './services/chart-report.service';
import { ChartTableService } from './services/chart-table.service';
import { CpppCalculationService } from './services/cppp-calculation.service';
import { PptxService } from './services/pptx.service';
import { PredictiveWidgetDataService } from './services/predictive-widget-data.service';
import { WidgetService } from './services/widget.service';
import { WidgetChartModule } from './widget-chart.module';

@NgModule({
  imports: [
    AppSharedModule,
    NgbModule,
    CollectionModule,
    KitchenAngularModule,
    ProjectModule,
    LexXiFilterPillComponent,
    ActionPlanModule,
    GridChartOptionsDialogComponent,
    RatingFieldSelectorDialogComponent,
    NumericMetadataFieldSelectorComponent,
    GridAnalyticItemSelectorDialogComponent,
    MatSidenavModule,
    SectionSelectorComponent,
    InteractiveSmartSummaryComponent,
    SectionFilterPipe,
    CommentDialogComponent,
    ActionPlanDialogComponent,
    WidgetMarkdownEditorComponent,
    NewspaperWidgletComponent,
    SmartSummaryFeedbackDialogComponent,
    CommentCompactCardComponent,
    PredictiveBreakdownWidgetetteComponent,
    PredictiveChartWidgetetteComponent,
    IsIconDisabledPipe,
    WidgetExpansionPanelComponent,
    WidgetAiInsightsComponent,
    PredictiveDriverWidgetetteComponent,
    WidgetInsightFeedComponent,
    CreateInsightFeedDialogComponent,
    SentimentBarComponent,
    SentimentIconComponent,
    WidgetAddFeedOptionsComponent,
    DashboardPillWrapperComponent,
    PinnedCommentDragDirective,
    TaxonomyPickerComponent,
    GridBreakdownTaxonomyConfigComponent,
    JourneyAnalyticItemSelectorDialogComponent,
    JourneyDetailsDialogComponent,
    WidgetJourneyComponent,
    AddToWidgetGroupDialogComponent,
    WidgetChartModule,
  ],
  providers: [
    PptxService,
    ChartDataService,
    ChartReportService,
    ChartTableService,
    ChartDisplayService,
    ChartCommentsService,
    PredictiveWidgetDataService,
    ActionPlanIpdService,
    CpppCalculationService,
    InteractiveSmartSummaryService,
    WidgetService,
  ],
  declarations: [
    TaxonomySearchDialogComponent,
    WidgetAddDialogComponent,
    WidgetFilterDialogComponent,
    WidgetSentimentFilterDialogComponent,
    WidgetComponent,
    WidgetMarkdownComponent,
    WidgetChartScatterplotComponent,
    WidgetChartVolumeComponent,
    WidgetDocumentListComponent,
    WidgetTopMoversComponent,
    DocumentListSettingsDialogComponent,
    WidgetCrosstabComponent,
    WidgetSentimentAccuracyComponent,
    WidgetTaxonomyMapComponent,
    WidgetTopicScoringComponent,
    CrosstabAnalyticItemsDialogComponent,
    WidgetAnalyticItemDialogComponent,
    AnalyticItemSelectorComponent,
    ChartOptionsDialogComponent,
    ChangeWidgetGroupDialogComponent,
    WidgetPredictiveComponent,
    PredictiveWidgetDatepickersComponent,
    WidgetImpactComponent,
    ImpactTableTrendIndicatorComponent,
    PredictiveChartOptionsDialogComponent,
    WidgetBigNumberComponent,
    BigNumberChartOptionsDialogComponent,
    BigNumberChartOptionsComponent,
    BigNumberMetadataSelectorDialogComponent,
    WidgetGridComponent,
    DonutChartOptionsDialogComponent,
    GaugeChartOptionsDialogComponent,
    BoxScoringDisplayComponent,
    SmartSummaryDialogComponent,
    PredictiveBreakdownDriversOptionsDialogComponent,
    PredictiveCrosstabComponent,
    WidgetNotesComponent,
    WidgetNotesEditorComponent,
    DocumentListSavedSearchComponent,
    WidgetCommentListComponent,
    CommentCardComponent,
  ],
  exports: [
    WidgetAddDialogComponent,
    WidgetFilterDialogComponent,
    WidgetSentimentFilterDialogComponent,
    WidgetComponent,
    RatingFieldSelectorDialogComponent,
    SmartSummaryFeedbackDialogComponent,
    CommentCompactCardComponent,
    WidgetAnalyticItemDialogComponent,
    WidgetChartModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WidgetModule {}
